import { LoginComponent } from "../app/components/login/login.component";

export const environment = {
    production: false,
    language: "sl",
    wgProfileHost: "https://fo5-evozila-api.borzen.si",
    wgPlatformHost: "https://fo5-evozila-platform.borzen.si",
    //wgProfileHost: "http://localhost:5005",
    //wgPlatformHost: "http://localhost:4300",

    loginComponent: LoginComponent,
    projIcon: "/assets/project-custom/images/borzen_logo_new.png",
    sidebarIcon: "/assets/project-custom/images/borzen_logo_new.png",
    projectCode: "BORZEN_EV",
    projectName: "",
    locale: 'sl-SI',
    useRouteAndMasterpageCache: true,
    ADLoginEnabled: false,
    dateFormat: 'DD.MM.YYYY',
    navigateAwayPopupEnabled: true,
    useEtag: true,
    newRegistrationLinkDocument: "",
    maxChunkNumber: 40,
    maxFileSizeInMb: 10,
    maxRecordNumberPerPageListing: 30,
    cacheEnabled: false,
    version: '1.1.0',
    showOnlyUserInHeader: true,
    googleClientId: "344277045222-cogqco4gh7j2ol4623eu1o1r3hrhomoo.apps.googleusercontent.com", // fo5
    useOldSearchViewFeature: false,
    usernameAlwaysToLower: true, // need this shit for EVOZILA1
    useInlineSearch: false,
    maxFileSizeInMbInMessenger: 5,
    projectSidebarName: "",
    theme: 'light'
};

